import { render, staticRenderFns } from "./BaseRadioButton.vue?vue&type=template&id=b283e6ee&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioButton.vue?vue&type=style&index=0&id=b283e6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283e6ee",
  null
  
)

export default component.exports